import React from 'react';
import './App.css';
import MarkoSaramandic from './MarkoSaramandic';

function App() {
  return (
    <div className="App">
      <MarkoSaramandic />
    </div>
  );
}

export default App;